import { useTranslate } from '@va/localization';
import { fontWeights, Heading3, Paragraph } from '@va/ui/design-system';
import { AiChatbotModelSettings } from '../AiChatbotModelSettings';

export const SettingsTab = () => {
  const translate = useTranslate();

  return (
    <div className='p-4u items-center justify-center text-center'>
      <Heading3 weight={fontWeights.semibold} className='text-display-regular! leading-display-regular! mb-4u'>
        {translate('aiChatbot.settingsScreen.title')}
      </Heading3>
      <Paragraph weight={fontWeights.medium} className='mb-10u'>
        {translate('aiChatbot.settingsScreen.description')}
      </Paragraph>

      <AiChatbotModelSettings />
    </div>
  );
};
